const KEY = "crm-kanban-on";
const EVENT = "crm-kanban-link";

export function kanbanOn(): boolean {
  return localStorage.getItem(KEY) !== "0";
}

export function setKanbanOn(on: boolean): void {
  localStorage.setItem(KEY, on ? "1" : "0");
  window.dispatchEvent(new Event(EVENT));
}

export function watchKanbanLink(listener: () => void): () => void {
  window.addEventListener(EVENT, listener);
  return () => window.removeEventListener(EVENT, listener);
}
